import { DropDownTreeFolder } from '@nbirl/nbi-common-ui-libs';

import { Folder } from '../models';

type SubFolderTreeProps = { folders: Folder[] };

export const SubFolderTree = ({ folders }: SubFolderTreeProps) => (
  <>
    {folders.map(({ id, name, subFolders }) => (
      <DropDownTreeFolder key={id} id={id} name={name}>
        {subFolders && subFolders.length > 0 ? (
          <SubFolderTree folders={subFolders} />
        ) : null}
      </DropDownTreeFolder>
    ))}
  </>
);
